export class InvoiceRendition {
  'id': number;
  'invoiceType': string;
  'number': string;
  'client': string;
  'name': string;
  'description': string;
  'amountCurrency': string;
  'amount': number;
  'ivaCurrency': string;
  'iva': number;
  'overbilled': number;
  'origin': string;
  'agent': string;
  'voucher': number;
  'hasError'?:boolean;

  constructor(data: any) {
    this.id = data.id;
    this.invoiceType = data.invoiceType;
    this.number = data.number;
    this.client = data.client;
    this.name = data.name;
    this.description = data.description;
    this.amountCurrency = data.amountCurrency;
    this.amount = data.amount;
    this.ivaCurrency = data.ivaCurrency;
    this.iva = data.iva;
    this.overbilled = data.overbilled;
    this.origin = data.origin;
    this.agent = data.agent;
    this.voucher = data.voucher;
    this.hasError = false;
  }

  formatFEtoBE() {
    let item = {
      typePayment: (this.client === 'Vendedor' || this.client === 'Captador') ? 1 : 2,
      voucherType: null,
      paymentType: 0,
      subtotalUSD: this.amountCurrency == 'U$S' ? Number(this.amount) : 0,
      subtotalIVAUSD: this.ivaCurrency == 'U$S' ? Number(this.iva) : 0,
      totalUSD: 0,
      subtotalARS: this.amountCurrency != 'U$S' ? Number(this.amount) : 0,
      subtotalIVAARS: this.ivaCurrency != 'U$S' ? Number(this.iva) : 0,
      totalARS: 0,
      billNumber: this.number,
      billDate: '',
      overbillingARS:
        this.amountCurrency != 'U$S' && this.overbilled > 0
          ? this.overbilled
          : 0,
      overbillingUSD:
        this.amountCurrency == 'U$S' && this.overbilled > 0
          ? this.overbilled
          : 0,
      concept: this.description,
      companyName: this.name, //Razon social,
      organizationId: 0,
      organizationName: '',
    };
    item.totalARS = Number(item.subtotalARS) + Number(item.subtotalIVAARS);
    item.totalUSD = Number(item.subtotalUSD) + Number(item.subtotalIVAUSD);
    return item;
  }
}

export class InvoiceRenditionAgentBilling {
  typePayment: number;
  voucherType: number | null;
  subtotalUSD: number;
  subtotalIVAUSD: number;
  totalUSD: number;
  subtotalARS: number;
  subtotalIVAARS: number;
  totalARS: number;
  billNumber: string;
  concept: string;
  companyName: string;
  organizationId: number;
  organizationName: string;

  constructor(data: InvoiceRendition) {
    this.typePayment = (data.client === 'Vendedor' || data.client === 'Captador') ? 1 : 2;
    this.voucherType = Number(data.voucher ?? 0);
    this.subtotalUSD = data.amountCurrency == 'U$S' ? Number(data.amount) : 0;
    this.subtotalIVAUSD = data.ivaCurrency == 'U$S' ? Number(data.iva) : 0;
    this.subtotalARS = data.amountCurrency != 'U$S' ? Number(data.amount) : 0;
    this.subtotalIVAARS = data.ivaCurrency != 'U$S' ? Number(data.iva) : 0;
    this.billNumber = data.number;

    this.concept = data.description;
    this.companyName = data.name;
    this.organizationId = 0;
    this.organizationName = data.agent;
    this.totalARS = Number(this.subtotalARS) + Number(this.subtotalIVAARS);
    this.totalUSD = Number(this.subtotalUSD) + Number(this.subtotalIVAUSD);
  }
}

export class InvoiceRenditionAgentPayment {
  typePayment: number;
  voucherType: number | null;
  paymentType: number;
  subtotalUSD: number;
  subtotalIVAUSD: number;
  totalUSD: number;
  subtotalARS: number;
  subtotalIVAARS: number;
  totalARS: number;
  billNumber: string;
  organizationId: number;
  organizationName: string;
  renditionId: number;
  renditionOperationType: number | null;
  voucherTypeEnum: null;
  checkNumber: string;
  checkDate: string;
  currency: string;
  ivaCurrency: string;

  constructor(data: InvoiceRendition) {
    this.typePayment = (data.client === 'Vendedor' || data.client === 'Captador') ? 1 : 2;
    this.voucherType = Number(data.voucher ?? 0);
    this.paymentType = 1;
    this.subtotalUSD = data.amountCurrency == 'U$S' ? Number(data.amount) : 0;
    this.subtotalIVAUSD = data.ivaCurrency == 'U$S' ? Number(data.iva) : 0;
    this.subtotalARS = data.amountCurrency != 'U$S' ? Number(data.amount) : 0;
    this.subtotalIVAARS = data.ivaCurrency != 'U$S' ? Number(data.iva) : 0;
    this.billNumber = data.number;
    this.organizationId = 0;
    this.renditionId = 0;
    this.organizationName = data.agent;
    this.totalARS = Number(this.subtotalARS) + Number(this.subtotalIVAARS);
    this.totalUSD = Number(this.subtotalUSD) + Number(this.subtotalIVAUSD);
    this.renditionOperationType = (data.client === 'Vendedor' || data.client === 'Captador') ? 1 : 2;
    this.voucherTypeEnum = null;
    this.checkDate = '';
    this.checkNumber = '';
    this.currency = data.amountCurrency == 'U$S' ? 'USD' : 'ARS';
    this.ivaCurrency = data.ivaCurrency == 'U$S' ? 'USD' : 'ARS';
  }
}

export class InvoiceRenditionBilling {
  typePayment: number;
  voucherType: number | null;
  paymentType: number;
  subtotalUSD: number;
  subtotalIVAUSD: number;
  totalUSD: number;
  subtotalARS: number;
  subtotalIVAARS: number;
  totalARS: number;
  billNumber: string;
  checkNumber: string;
  checkDate: string;
  overbillingLocal: number;
  overbillingUSD: number;
  concept: string;
  companyName: string;
  currency: string;
  ivaCurrency: string;

  constructor(data: InvoiceRendition) {
    this.typePayment = (data.client === 'Vendedor' || data.client === 'Captador') ? 1 : 2;
    this.voucherType = Number(data.voucher ?? 0);
    this.paymentType = 3;
    this.subtotalUSD = data.amountCurrency == 'U$S' || data.amountCurrency == 'USD' ? Number(data.amount) : 0;
    this.subtotalIVAUSD = data.ivaCurrency == 'U$S' || data.ivaCurrency == 'USD' ? Number(data.iva) : 0;
    this.totalUSD = 0;
    this.subtotalARS = data.amountCurrency != 'U$S' && data.amountCurrency != 'USD' ? Number(data.amount) : 0;
    this.subtotalIVAARS = data.ivaCurrency != 'U$S' && data.ivaCurrency != 'USD' ? Number(data.iva) : 0;
    this.totalARS = 0;
    this.checkNumber = '';
    this.checkDate = '';
    this.billNumber = data.number;
    this.overbillingLocal =
      data.amountCurrency != 'U$S' && data.amountCurrency != 'USD' && data.overbilled > 0
        ? Number(data.overbilled)
        : 0;
    this.overbillingUSD =
      (data.amountCurrency == 'U$S' || data.amountCurrency == 'USD') && data.overbilled > 0
        ? Number(data.overbilled)
        : 0;
    this.concept = data.description;
    this.companyName = data.name; //Razon social;
    this.currency = data.amountCurrency == 'U$S' || data.amountCurrency == 'USD' ? 'USD' : 'ARS';
    this.ivaCurrency = data.ivaCurrency == 'U$S' || data.ivaCurrency == 'USD' ? 'USD' : 'ARS';
  }
}
